import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UtilisateurSelect from './UtilisateurSelect';

class UtilisateurSelectContainer extends React.Component {

    render() {
        const { utilisateurs, value, isLoading, onChange, isRequired, error, disabled, onlyUserId } = this.props;

        return (
            <UtilisateurSelect
                utilisateurs={utilisateurs}
                value={value}
                isLoading={isLoading}
                onChange={onChange}
                error={error}
                isRequired={isRequired}
                disabled={disabled ? disabled === true : false}
                onlyUserId={onlyUserId ? onlyUserId : 0}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    utilisateurs: state.utilisateur.utilisateurs[ownProps.namespace].items,
    isLoading: state.utilisateur.utilisateurs[ownProps.namespace].isLoading
});


UtilisateurSelectContainer.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    excluded: PropTypes.number,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    disabled: PropTypes.bool,
    onlyUserId: PropTypes.number
};

export default connect(mapStateToProps, null)(UtilisateurSelectContainer);